











































































































import {Component, Prop, Watch, Mixins} from 'vue-property-decorator'
import {$, Helper, MixinQueryRouter} from 'simpli-web-sdk'
import {MotoristaTransbordo} from '@/model/resource/MotoristaTransbordo'
import {MotoristaTransbordoCollection} from '@/model/collection/MotoristaTransbordoCollection'
import {ListMotoristaTransbordoSchema} from '@/schema/resource/MotoristaTransbordo/ListMotoristaTransbordoSchema'
import {CsvMotoristaTransbordoSchema} from '@/schema/resource/MotoristaTransbordo/CsvMotoristaTransbordoSchema'

@Component
export default class ListMotoristaTransbordoView extends Mixins(
  MixinQueryRouter
) {
  schema = new ListMotoristaTransbordoSchema()
  collection = new MotoristaTransbordoCollection()

  async created() {
    await this.query()
  }

  goToPersistView(item: MotoristaTransbordo) {
    Helper.pushByName('editMotoristaTransbordo', item.idMotoristaFk)
  }

  async downloadCsv() {
    const {params} = this.collection
    delete params.ascending
    delete params.orderBy
    delete params.page
    delete params.limit

    const csv = new MotoristaTransbordoCollection()
      .clearFilters()
      .addFilter(params)

    await csv.listCsvMotoristaTransbordo()
    new CsvMotoristaTransbordoSchema().downloadCsv(csv.all())
  }
}
